var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"5","cy":"5","r":"5","fill":"#66BB6A"}})])}
var staticRenderFns = []

export { render, staticRenderFns }